import React from "react";
import { View, Text } from "react-native";

/**
 * Placeholder only
 * Will be deleted when tabs are made
 */
const TabPlaceholder = () => {
  return (
    <View className="flex-1 items-center justify-center py-20">
      <Text className="text-slate text-base font-medium">TO-DO</Text>
    </View>
  );
};

export default TabPlaceholder;
